import React, { Component } from "react";
import {
  Button,
  Grid,
  Header,
  List,
  Segment,
  Message,
  Form,
  Accordion
} from "semantic-ui-react";
import { BrowserRouter as Router, Link, Route } from "react-router-dom";
import DevCard from "./DevCard";
import PageHeader from "./components/PageHeader";
const people = [
  {
    name: "John Nguyen",
    title: "President / CEO",
    image: require("./resources/p1.jpeg"),
    description:
      "With a focus on solution architecture and extensive real world technology experience, John brings web and mobile marketing solutions to life and leads team members and customer projects to project completion, with a focus on yielding a high Return on Marketing Investment (ROMI) for the customer."
  },
  {
    name: "Jennifer Wang",
    title: "CHIEF TECHNICAL OFFICER",
    image: require("./resources/p2.jpeg"),
    description:
      "Focuses on building responsive web and mobile solutions while emphasizing quality by incorporating best practices, conventions, and tools. Her expertise is immeasurable when it comes to managing exceptionally complex development initiatives across multiple agencies and team members."
  },
  {
    name: "Eric Craney",
    title: "Lead Designer",
    image: require("./resources/p3.jpeg"),
    description:
      "Taking the lead on all projects involving pixels while in their early concept and design stages. He loves taking awesome ideas and working to realize and visualize them. You can usually find him at his desk working on the latest motion graphics segment or mobile app prototype."
  },
  {
    name: "Alison Dempsey",
    title: "Client Manager",
    image: require("./resources/p4.jpeg"),
    description:
      "Client satisfaction is paramount to our success. Alison is the main point of contact, project manager, and trusted business advisor to our clients. As the account manager, she serves as the line of communication between the marketing team and customers. She is also responsible for all analytics and reporting for SEO clients."
  }
];

class Team extends Component {
  render() {
    const headerColor = "#2c3e50";

    return (
      <div
        style={{
          padding: 50
        }}
      >
        <PageHeader
          image={require("./resources/logo.png")}
          title={"OUR TEAM"}
          subTitle={"PASSIONATE CREATORS. BOUNDLESS TALENT."}
        />
        <div class="ui stackable grid" style={{ paddingTop: 50 }}>
          <div class="two column row">
            <div class="column">
              <DevCard
                name={people[0].name}
                title={people[0].title}
                image={people[0].image}
                description={people[0].description}
              />
            </div>
            <div class="column">
              <DevCard
                name={people[1].name}
                title={people[1].title}
                image={people[1].image}
                description={people[1].description}
              />
            </div>
          </div>
          <div class="two column row">
            <div class="column">
              <DevCard
                name={people[2].name}
                title={people[2].title}
                image={people[2].image}
                description={people[2].description}
              />
            </div>
            <div class="column">
              <DevCard
                name={people[3].name}
                title={people[3].title}
                image={people[3].image}
                description={people[3].description}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Team;



// WEBPACK FOOTER //
// ./src/Team.js